import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'

export const createWebsiteLogo = (
  parentId: string,
  masterBlockId?: MasterBlockId,
): WebsiteLogoInterface => {
  return {
    ...generateBaseEntity(EntityTypeEnum.WebsiteLogo, parentId, masterBlockId),
    logoFileId: null,
    logoText: 'Logo',
  }
}
